/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Ratings api bizo
 */

import { Ratings } from '@zcode/bizos'
export default Ratings
